export default "__VITE_ASSET__CboZxEwI__"